import React from 'react';
import ReactNumberFormat from 'react-number-format';

interface NumberFormatCustomProps {
  inputRef?: (instance: any) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumberFormat: React.FC<NumberFormatCustomProps> = ({
  inputRef,
  onChange,
  name,
  ...other
}) => {
  return (
    <ReactNumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values: any) => {
        onChange({
          target: {
            name,
            value: values.value,
          },
        });
      }}
      isNumericString
    />
  );
};
export default NumberFormat;
